module.exports = __webpack_public_path__ + "img/0042.75f33144.jpg";